var lineoption; //柱状图配置
var pieoption; //饼状图
var pieoptiontwo;
lineoption = {
  title: {
    // text: "科室进度对比",
    top: "2%",
    // subtext: 'Fake Data',
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow"
    }
  },
  legend: {
    orient: "horizontal",
    show:true,
     top: "6%",
    y: "bottom"
  },
  grid: {
    top: 0,
    left: "3%",
    height: "90%",
    right: "4%",
    bottom: "3%",
    containLabel: true
  },
  interval: 0,//使x轴上的文字显示完全,
  xAxis: [
    {
      type: "category",
      show:true,
      position: 'bottom',
      axisLabel: {
        width:60,
        formatter:function(value){  
          var str = ""; 
          var num = 1; //每行显示字数 
          var valLength = value.length; //该项x轴字数  
          var rowNum = Math.ceil(valLength / num); // 行数  
          
          if(rowNum > 1) {
              for(var i = 0; i < rowNum; i++) {
                  var temp = "";
                  var start = i * num;
                  var end = start + num;
                  
                  temp = value.substring(start, end) + "\n";
                  str += temp; 
              }
              return str;
          } else {
              return value;
          } 
      },
      //   formatter: function (value) {
      //     // 将过长的文本分割并换行
      //     return value.split("").join("\n");
      // },
        // rotate: 45, // 旋转角度
        interval: 0 // 强制显示所有标签
    },
      data: ["内科", "外科", "护理科", "神经科", "心脏科", "皮肤科", "其他科"],
    },
  ],
  yAxis: [
    {
      type: "value"
    }
  ],
  series: [
    {
      name: "已看完",
      type: "bar",
      stack: "总人数",
      emphasis: {
        focus: "series"
      },
      seriesLayoutBy: 'row',
    //   itemStyle:{ 
    //     normal:{ 
    //         label:{ 
    //            show: true, 
    //            formatter: '{a}:{c}' 
    //         }, 
    //         labelLine :{show:true}
    //     } 
    // },
      data: [320, 332, 301, 334, 390, 330, 320]
    },
    {
      name: "进行中",
      type: "bar",
      stack: "总人数",
      emphasis: {
        focus: "series"
      },   
      data: [120, 132, 101, 134, 90, 230, 210]
    },
    {
      name: "未开始",
      type: "bar",
      stack: "总人数",
      emphasis: {
        focus: "series"
      },
     
      data: [220, 182, 191, 234, 290, 330, 310]
    }
  ],
  color: ["#70b8ff", "#fbd0a4", "#f08cf7"]
};
pieoption = {
  title: {
    x: "left",
    text: "全体进度占比"
    // subtext: 'Fake Data',
    // left: 'center'
  },
  tooltip: {
    trigger: "item"
  },
  legend: {
    orient: "horizontal",
    y: "bottom"
  },
  series: [
    {
      name: "观看详情",
      type: "pie",
      radius: "50%",
      data: [
        //   { value: 1048, name: 'Search Engine' },
        //   { value: 735, name: 'Direct' },
        //   { value: 580, name: 'Email' },
        //   { value: 484, name: 'Union Ads' },
        //   { value: 300, name: 'Video Ads' }
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)"
        }
      }
    }
  ]
};
pieoptiontwo = {
  title: {
    text: "进行中进度占比",
    // subtext: 'Fake Data',
    x: "left"
  },
  tooltip: {
    trigger: "item",
  },
  legend: {
    orient: "horizontal",
    y: "bottom"
  },
  series: [
    {
      name: "进行中详情",
      type: "pie",
      radius: "50%",
      data: [
        { value: 1048, name: "Search Engine" },
        { value: 735, name: "Direct" },
        { value: 580, name: "Email" },
        { value: 484, name: "Union Ads" },
        { value: 300, name: "Video Ads" }
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)"
        }
      }
    }
  ]
};
export default { lineoption, pieoption, pieoptiontwo };
